export default __webpack_public_path__ + "static/shoppee-4b7154858ba52e3abe6d4b859cf5cdb2.png";